export default {
  sections: {
    payment: 'Payment',
  },
  labels: {
    proceed_to_payment: 'Proceed to payment via link or scan the QR code',
  },
  buttons: {
    generate_new_link: 'Generate new link',
    copy_link: 'Copy link',
    pay_now: 'Pay now',
  },
  toasts: {
    failed_to_create_payment_link: 'Failed to load payment link',
  },
};
